import React from 'react'
import { Section, Article, ArticleHeading, ArticleHeadingH4, ArticleHeadingH3, ArticleHeadingH5 } from '../content'
import { md } from '../../lib/remarkable'

function BlockText ({ title, value, children, titleLevel= 2, contentLevel = 'section' }) {

  const html = React.useMemo(() => {
    if (typeof value !== 'string') {
      return null
    }
    if (!value) return null
    return <div>{md.render(value)}</div>
  }, [value])

  let TitleComponent
  switch (titleLevel) {
    case 2:
      TitleComponent = ArticleHeading
      break;
    case 3:
      TitleComponent = ArticleHeadingH3
      break;
    case 4:
      TitleComponent = ArticleHeadingH4
      break;
    case 5:
      TitleComponent = ArticleHeadingH5
      break;
    default:
      TitleComponent = ArticleHeading
  }

  const ContentComponent = contentLevel === 'section' ? Section : Article

  return (
    <ContentComponent>
      { title && <TitleComponent>{title}</TitleComponent> }
      {html}
      {children}
    </ContentComponent>
  )
}

export default BlockText
